import { useSearchParams } from 'react-router-dom';
import { EntryPageTemplate } from '#/guest-aps/templates/entry-page-template';
import { usePoi } from '#/guest-aps/services/use-poi';
import { useAmplitudeOpenFromLink } from '#/guest-aps/hooks/use-amplitude-open-from-link';

export const PoiEntryPage = () => {
  const [searchQuery] = useSearchParams();
  const { parkinglot, getPoiStatus } = usePoi({ poiId: searchQuery.get('id') });

  useAmplitudeOpenFromLink({
    url: window.location.href,
    source: '圖資網頁',
    code: null,
    name: null,
  });

  return (
    <EntryPageTemplate
      isParkinglotFetched={getPoiStatus === 'success'}
      parkinglot={parkinglot}
    />
  );
};
